import {Action} from '@ngrx/store';
import {SalesPageSettings} from '../../model/sales-page-settings.model';

/**
 * All actions of the sales offer sub-store are described here
 * An action can have an optional payload
 */

/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 */
export const UPDATE_BID_STATUS = '[SALES_OFFER] UPDATE_BID_STATUS';
export const UPDATE_BID_STATUS_GENERAL = '[SALES_OFFER] UPDATE_BID_STATUS_GENERAL';
export const UPDATE_BID_STATUS_DEALER_SPECIFIC = '[SALES_OFFER] UPDATE_BID_STATUS_DEALER_SPECIFIC';
export const UPDATE_OFFERS = '[SALES_OFFER] UPDATE_OFFERS';
export const UPDATED_OFFERS = '[SALES_OFFER] UPDATED_OFFERS';
export const UPDATE_OFFER = '[SALES_OFFER] UPDATE_OFFER';
export const UPDATE_PAGE_SETTINGS = '[SALES_OFFER] UPDATE_PAGE_SETTINGS';
export const UPDATE_PAGE_SETTINGS_PAGE = '[SALES_OFFER] UPDATE_PAGE_SETTINGS_PAGE';

/**
 * UPDATE ACTIONS
 */

// this actions are used in combination with web sockets, where we receive a bid [general | dealer specific] status dto and update the store with it
/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 */
export class UpdateBidStatusAction implements Action {
  readonly type = UPDATE_BID_STATUS;

  constructor(public payload: BidStatusDto) {
  }
}

export class UpdateBidStatusGeneralAction implements Action {
  readonly type = UPDATE_BID_STATUS_GENERAL;

  constructor(public payload: BidGeneralStatusDto) {
  }
}

export class UpdateBidStatusDealerSpecificAction implements Action {
  readonly type = UPDATE_BID_STATUS_DEALER_SPECIFIC;

  constructor(public payload: BidDealerStatusDto) {
  }
}

export class UpdateOffersAction implements Action {
  readonly type = UPDATE_OFFERS;
}

export class UpdateOfferAction implements Action {
  readonly type = UPDATE_OFFER;

  constructor(public payload: OfferDto) {
  }
}

export class UpdatePageSettings implements Action {
  readonly type = UPDATE_PAGE_SETTINGS;

  constructor(public payload: SalesPageSettings) {
  }
}

export class UpdatePageSettingsPage implements Action {
  readonly type = UPDATE_PAGE_SETTINGS_PAGE;

  constructor(public page: number) {
  }
}

/**
 * UPDATED ACTIONS
 */

export class UpdatedOffersAction implements Action {
  readonly type = UPDATED_OFFERS;

  constructor(public payload: OfferDto[]) {
  }
}

export type SalesOfferAction =
    UpdateBidStatusAction
    | UpdateBidStatusGeneralAction
    | UpdateBidStatusDealerSpecificAction
    | UpdateOffersAction
    | UpdatedOffersAction
    | UpdatePageSettings
    | UpdatePageSettingsPage
    | UpdateOfferAction;
